import { Text } from '@chakra-ui/react'
import type { FC } from 'react'

interface Props {
  showDescription?: boolean
}

const WelcomeDescription: FC<Props> = ({ showDescription = true }) => {
  if (!showDescription) {
    return null
  }

  return (
    <Text textAlign="center" color="fg.muted" fontSize="sm">
      Hang tight! This will take ~2 minutes. We're analyzing your business information to create a comprehensive context
      that powers our AI recommendations.
    </Text>
  )
}

export default WelcomeDescription
